export const HANDICAP_LINE = 'Line';

export class Settings {

  constructor(json, fileId = null) {
    this.data = json;
    this.fileId = fileId;
    this.data.defaultVesselIdx = parseInt(this.data.defaultVesselIdx) || 0;
    this._migrateSettings();
    console.log('Loaded settings:'+this.toJSON());
  }

  getFileId() { return this.fileId; }
  setFileId(id) { this.fileId = id; }

  _migrateSettings() {
    if (!this.data.handicapNames) {
      this.data.handicapNames = [];
    }
    if (!this.data.raceVessels) {
      this.data.raceVessels = [];
    }
    
    for (const vessel of this.data.vessels) {
      if (vessel.useCalculatedTwa !== undefined && !vessel.calculatedWind) {
        vessel.calculatedWind = {
          enabled: vessel.useCalculatedTwa || false,
          useSOG: false,
          useLeeway: true,
          leewayK: vessel.leewayK || 10
        };
        delete vessel.useCalculatedTwa;
        delete vessel.leewayK;
      }
      if (!vessel.calculatedWind) {
        vessel.calculatedWind = {
          enabled: false,
          useSOG: false,
          useLeeway: true,
          leewayK: 10
        };
      }
    }
    
    for (const vessel of this.data.raceVessels) {
      if (!vessel.handicapValues) {
        vessel.handicapValues = [];
      }
      if (vessel.handicapValues.length > 0 && vessel.handicapValues[0] === '1.0') {
        vessel.handicapValues.shift();
      }
    }
  }

  getDefaultVessel() {
    return this.data.vessels[this.data.defaultVesselIdx];
  }

  getCalculatedWind() {
    return this.getDefaultVessel().calculatedWind;
  }

  getDefaultPolarFile() {
    return this.getDefaultVessel().standardPolar.file;
  }

  setDefaultPolarFile(fileName) {
    this.getDefaultVessel().standardPolar.file = fileName;
  }

  clearDefaultPolarFile() {
    this.getDefaultVessel().standardPolar.file = null;
    this.clearDefaultPolarCache();
  }

  setDefaultPolarCache(polar) {
    this._polarCache = polar;
  }

  getDefaultPolarCache() {
    return this._polarCache;
  }

  clearDefaultPolarCache() {
    this._polarCache = null;
  }

  isPolarCached() {
    return this._polarCache != null;
  }

  toJSON() {
    return JSON.stringify(this.data, null, 2);
  }

  getRaceVessels() {
    const res = [];
    for(const v of this.data.raceVessels){
      res.push(new RaceVessel(v));
    }
    return res;
  }

  addRaceVessel(v) {
    const handicapValues = new Array(this.data.handicapNames.length).fill(null);
    this.data.raceVessels.push({...v, handicapValues});
  }

  getRaceVesselByMMSI(mmsi) {
    const vessel = this.data.raceVessels.find(v => v.mmsi === mmsi);
    return vessel ? new RaceVessel(vessel) : null;
  }

  getDefaultRaceVessel() {
    const vessel = this.data.raceVessels.find(v => v.vesselIdx === this.data.defaultVesselIdx);
    return vessel ? new RaceVessel(vessel) : null;
  }

  getHandicapNames() {
    return [HANDICAP_LINE, ...this.data.handicapNames];
  }

  addHandicapName(name) {
    this.data.handicapNames.push(name);
    for (const vessel of this.data.raceVessels) {
      vessel.handicapValues.push(null);
    }
  }

  delHandicapName(idx) {
    if (idx === 0) return;
    this.data.handicapNames.splice(idx - 1, 1);
    for (const vessel of this.data.raceVessels) {
      vessel.handicapValues.splice(idx - 1, 1);
    }
  }

  delRaceVessel(vesselIdx) {
    this.data.raceVessels.splice(vesselIdx, 1);
  }

  getHandicapIdx(name) {
    if (name === HANDICAP_LINE) return 0;
    const idx = this.data.handicapNames.indexOf(name);
    return idx === -1 ? -1 : idx;
  }

  static createDefault() {
    return {
      defaultVesselIdx: 0,
      vessels: [
        {
          id: crypto.randomUUID(),
          name: 'Default',
          standardPolar: { file: null },
          calculatedWind: {
            enabled: false,
            useSOG: false,
            useLeeway: true,
            leewayK: 10
          }
        }
      ],
      handicapNames: [],
      raceVessels: []
    };
  }

  static createExampleRaceVessels() {
    return [
        { 
          shipName: 'Default',
          mmsi: null,
          vesselIdx:0,
          color:'#000000',
          handicapValues: []
        }
      ];
  }
}

export class RaceVessel {
  constructor(json) {
    this.data = json;
  }

  getName() {
    return this.data.shipName;
  }

  getMMSI() {
    return this.data.vesselIdx == null ? this.data.mmsi : null;
  }

  getVesselIdx() {
    return this.data.vesselIdx;
  }

  getVesselId() {
    return this.getMMSI() != null ? `mmsi-${this.getMMSI()}` : `idx-${this.getVesselIdx()}`;
  }

  getColor() {
    return this.data.color;
  }

  getHandicapValues() {
    return this.data.handicapValues;
  }

  getHandicap(idx) {
    if (idx === 0) return 1.0;
    if (idx < 1 || idx > this.data.handicapValues.length) return null;
    const value = this.data.handicapValues[idx - 1];
    if (value === null || value === undefined) return null;
    return parseFloat(value);
  }

  getHandicapStr(idx) {
    if (idx < 1 || idx > this.data.handicapValues.length) return null;
    return this.data.handicapValues[idx - 1];
  }

  setHandicap(idx, value) {
    if (idx === 0) return;
    if (idx < 1 || idx > this.data.handicapValues.length) return;
    this.data.handicapValues[idx - 1] = value;
  }
  
}
